import { __assign, __spreadArrays } from "tslib";
import { ScenarioActionType, TicketLabelsActionType, spotterEmptyActionMap, ALL_PRIORITIES, ALL_TASK_TYPES, NotificationTypeAction } from ".";
import { CallPriority, ContentTaskPriority } from "..";
import { RandomGenerator } from "../..";
import { testDataCreator } from '@wix/answers-lib';
export var createNotificationOptionsBuilder = testDataCreator(function () { return ({
    toArticleAuthor: false,
    toArticleAuthorManager: false,
    toCallCenterQueueAssignees: false,
    toCallParticipants: false,
    toCallParticipantsManagers: false,
    toRelevantAgent: false,
    toRelevantAgentManager: false,
    toTicketAssignedAgentOrGroup: false,
    toTicketAssignedAgentManager: false,
    toChatParticipants: false,
    toChatParticipantsManagers: false,
    toCompanyAccountManager: false,
    toLastAgentReplier: false,
    toTicketAgents: false,
}); });
export var changeTicketStatusActionBuilder = testDataCreator(function () { return ({
    disabled: false,
    actionType: ScenarioActionType.CHANGE_TICKET_STATUS,
}); });
export var createArticleTaskBuilder = testDataCreator(function () { return ({
    disabled: false,
    actionType: ScenarioActionType.CREATE_ARTICLE_TASK,
    contentTaskPriority: ContentTaskPriority.MEDIUM,
}); });
export var createNotificationActionBuilder = testDataCreator(function () { return (__assign({ disabled: false, actionType: ScenarioActionType.SEND_NOTIFICATION, notificationRecipients: {
        emails: [],
        groupIds: [],
        userIds: [],
    }, message: '' }, createNotificationOptionsBuilder())); });
export var unassignTicketActionBuilder = testDataCreator(function () { return ({
    actionType: ScenarioActionType.UNASSIGN_TICKET,
    disabled: false,
}); });
export var addInternalNoteActionBuilder = testDataCreator(function () { return ({
    disabled: false,
    actionType: ScenarioActionType.ADD_INTERNAL_NOTE,
    noteContent: '',
}); });
export var setAssigneeTicketActionBuilder = testDataCreator(function () { return ({
    disabled: false,
    actionType: ScenarioActionType.REASSIGN_TICKET,
}); });
export var setTicketPriorityActionBuilder = testDataCreator(function () { return ({
    disabled: false,
    actionType: ScenarioActionType.SET_TICKET_PRIORITY,
}); });
export var addAgentReplyActionBuilder = testDataCreator(function () { return ({
    disabled: false,
    actionType: ScenarioActionType.ADD_AGENT_REPLY,
    replyContent: '',
}); });
export var setTicketLabelsActionBuilder = testDataCreator(function () { return ({
    disabled: false,
    actionType: ScenarioActionType.SET_TICKET_LABELS,
    labelIds: [],
    labelsActionType: TicketLabelsActionType.ADD,
}); });
export var sendChatAutoReplyBuilder = testDataCreator(function () { return ({
    disabled: false,
    actionType: ScenarioActionType.SEND_CHAT_AUTO_REPLY,
    messageContent: '',
}); });
export var endAllHandlingActionBuilder = testDataCreator(function () { return ({
    disabled: false,
    actionType: ScenarioActionType.END_ALL_HANDLING,
}); });
export var endChatActionBuilder = testDataCreator(function () { return ({
    disabled: false,
    actionType: ScenarioActionType.END_CHAT,
}); });
export var deleteCallRecordingActionBuilder = testDataCreator(function () { return ({
    disabled: false,
    actionType: ScenarioActionType.DELETE_CALL_RECORDING,
}); });
export var createCallbackActionBuilder = testDataCreator(function () { return ({
    disabled: false,
    actionType: ScenarioActionType.CREATE_CALLBACK,
    callPriority: CallPriority.NORMAL,
}); });
export var scenarioActionBuilder = function (actionType, override) {
    return testDataCreator(spotterEmptyActionMap(actionType))(override);
};
// Random action generators
export var randomArticleTaskAction = function (allAgents) {
    var taskType = RandomGenerator.selectRandom(__spreadArrays(ALL_TASK_TYPES));
    var description = RandomGenerator.randomString();
    var priority = RandomGenerator.selectRandom(ALL_PRIORITIES);
    return createArticleTaskBuilder({
        assignedUserId: allAgents[0].id,
        contentTaskPriority: priority,
        contentTaskType: taskType,
        description: description,
    });
};
export var randomNotificationAction = function (agents, groups) {
    if (agents === void 0) { agents = []; }
    if (groups === void 0) { groups = []; }
    var notification = RandomGenerator.selectRandom([NotificationTypeAction.EMAIL, NotificationTypeAction.IN_APP_NOTIFICATION]);
    var userIds = agents.map(function (assignee) { return assignee.id; });
    var groupIds = groups.map(function (assignee) { return assignee.id; });
    return createNotificationActionBuilder({
        notificationChannel: notification,
        notificationRecipients: {
            userIds: userIds,
            groupIds: groupIds,
            emails: [],
        },
    });
};
//# sourceMappingURL=actions.builders.js.map